export default __webpack_public_path__ + "static/media/video.e683f436.mp4";